import react from 'react'
import './loading.scss'

const Loading = (props:any) => {

    return (
        <div className="align-items-center flex justify-content-center wrap">
            <div className="loading">
                <div className="bounceball"></div>
                <div className="text">Loading {props.message}</div>
            </div>
        </div>
        // <div className='loaderContainer'>
        //     <div className="loader">
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //         <span className='loaderSpan'></span>
        //     </div>

        // </div>

    )

}
export default Loading